/**
 * Panel
 * @module elements/panel
 */
const html = require('choo/html')

module.exports = function Panel (args) {
  const {
    color = 'purple',
    noPadding = false,
    children,
    size = 'large',
    hidden = false,
    id = null
  } = args
  let paddingClass = ''
  if (noPadding) {
    paddingClass = 'no-padding'
  }
  let hiddenClass = hidden ? 'hidden' : ''
  const divProps = {};
  if (id) {
    divProps.id = id;
  }

  return html`
    <div class="panel panel-${color} panel-${size} ${paddingClass} ${hiddenClass}" ${divProps}>
      ${children}
    </div>
  `
}
